var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('el-table',{attrs:{"data":_vm.tree,"row-key":"label","border":"","tree-props":{children: 'children'}}},[_c('el-table-column',{attrs:{"prop":"label","label":"角色"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }